"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.string.small.js");
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _checkbox = _interopRequireDefault(require("@gravity/checkbox"));
var _stylingConstants = _interopRequireDefault(require("@gravity/styling-constants"));
var _themeMapper = require("@gravity/theme-mapper");
var _themeProvider = require("@gravity/theme-provider");
var _utils = require("@gravity/utils");
var _type = require("./type");
var _jsxFileName = "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/MultiDropDown/lib/Option.js",
  _templateObject,
  _templateObject2,
  _templateObject3,
  _templateObject4,
  _templateObject5,
  _templateObject6,
  _templateObject7,
  _this = void 0;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_1ga3pmbvzg() {
  var path = "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/MultiDropDown/lib/Option.js";
  var hash = "fbba49264e4c24b7f1245f062d01a0708266f6e0";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/MultiDropDown/lib/Option.js",
    statementMap: {
      "0": {
        start: {
          line: 14,
          column: 16
        },
        end: {
          line: 47,
          column: 1
        }
      },
      "1": {
        start: {
          line: 23,
          column: 8
        },
        end: {
          line: 23,
          column: 92
        }
      },
      "2": {
        start: {
          line: 25,
          column: 8
        },
        end: {
          line: 27,
          column: 49
        }
      },
      "3": {
        start: {
          line: 49,
          column: 20
        },
        end: {
          line: 55,
          column: 1
        }
      },
      "4": {
        start: {
          line: 50,
          column: 31
        },
        end: {
          line: 50,
          column: 76
        }
      },
      "5": {
        start: {
          line: 57,
          column: 16
        },
        end: {
          line: 66,
          column: 1
        }
      },
      "6": {
        start: {
          line: 62,
          column: 35
        },
        end: {
          line: 62,
          column: 47
        }
      },
      "7": {
        start: {
          line: 67,
          column: 14
        },
        end: {
          line: 83,
          column: 1
        }
      },
      "8": {
        start: {
          line: 75,
          column: 8
        },
        end: {
          line: 76,
          column: 39
        }
      },
      "9": {
        start: {
          line: 85,
          column: 20
        },
        end: {
          line: 87,
          column: 1
        }
      },
      "10": {
        start: {
          line: 93,
          column: 15
        },
        end: {
          line: 124,
          column: 1
        }
      },
      "11": {
        start: {
          line: 94,
          column: 19
        },
        end: {
          line: 94,
          column: 23
        }
      },
      "12": {
        start: {
          line: 95,
          column: 2
        },
        end: {
          line: 109,
          column: 3
        }
      },
      "13": {
        start: {
          line: 96,
          column: 4
        },
        end: {
          line: 101,
          column: 6
        }
      },
      "14": {
        start: {
          line: 103,
          column: 4
        },
        end: {
          line: 108,
          column: 6
        }
      },
      "15": {
        start: {
          line: 110,
          column: 2
        },
        end: {
          line: 123,
          column: 4
        }
      },
      "16": {
        start: {
          line: 113,
          column: 74
        },
        end: {
          line: 113,
          column: 91
        }
      },
      "17": {
        start: {
          line: 117,
          column: 78
        },
        end: {
          line: 117,
          column: 95
        }
      },
      "18": {
        start: {
          line: 126,
          column: 0
        },
        end: {
          line: 153,
          column: 2
        }
      },
      "19": {
        start: {
          line: 155,
          column: 0
        },
        end: {
          line: 162,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 22,
            column: 22
          },
          end: {
            line: 22,
            column: 23
          }
        },
        loc: {
          start: {
            line: 23,
            column: 8
          },
          end: {
            line: 23,
            column: 92
          }
        },
        line: 23
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 24,
            column: 20
          },
          end: {
            line: 24,
            column: 21
          }
        },
        loc: {
          start: {
            line: 25,
            column: 8
          },
          end: {
            line: 27,
            column: 49
          }
        },
        line: 25
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 50,
            column: 21
          },
          end: {
            line: 50,
            column: 22
          }
        },
        loc: {
          start: {
            line: 50,
            column: 31
          },
          end: {
            line: 50,
            column: 76
          }
        },
        line: 50
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 62,
            column: 26
          },
          end: {
            line: 62,
            column: 27
          }
        },
        loc: {
          start: {
            line: 62,
            column: 35
          },
          end: {
            line: 62,
            column: 47
          }
        },
        line: 62
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 74,
            column: 15
          },
          end: {
            line: 74,
            column: 16
          }
        },
        loc: {
          start: {
            line: 75,
            column: 8
          },
          end: {
            line: 76,
            column: 39
          }
        },
        line: 75
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 93,
            column: 15
          },
          end: {
            line: 93,
            column: 16
          }
        },
        loc: {
          start: {
            line: 93,
            column: 96
          },
          end: {
            line: 124,
            column: 1
          }
        },
        line: 93
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 113,
            column: 68
          },
          end: {
            line: 113,
            column: 69
          }
        },
        loc: {
          start: {
            line: 113,
            column: 74
          },
          end: {
            line: 113,
            column: 91
          }
        },
        line: 113
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 117,
            column: 72
          },
          end: {
            line: 117,
            column: 73
          }
        },
        loc: {
          start: {
            line: 117,
            column: 78
          },
          end: {
            line: 117,
            column: 95
          }
        },
        line: 117
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 23,
            column: 8
          },
          end: {
            line: 23,
            column: 92
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 23,
            column: 27
          },
          end: {
            line: 23,
            column: 58
          }
        }, {
          start: {
            line: 23,
            column: 61
          },
          end: {
            line: 23,
            column: 92
          }
        }],
        line: 23
      },
      "1": {
        loc: {
          start: {
            line: 25,
            column: 8
          },
          end: {
            line: 27,
            column: 49
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 26,
            column: 12
          },
          end: {
            line: 26,
            column: 53
          }
        }, {
          start: {
            line: 27,
            column: 12
          },
          end: {
            line: 27,
            column: 49
          }
        }],
        line: 25
      },
      "2": {
        loc: {
          start: {
            line: 50,
            column: 31
          },
          end: {
            line: 50,
            column: 76
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 50,
            column: 48
          },
          end: {
            line: 50,
            column: 63
          }
        }, {
          start: {
            line: 50,
            column: 66
          },
          end: {
            line: 50,
            column: 76
          }
        }],
        line: 50
      },
      "3": {
        loc: {
          start: {
            line: 75,
            column: 8
          },
          end: {
            line: 76,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 75,
            column: 9
          },
          end: {
            line: 75,
            column: 34
          }
        }, {
          start: {
            line: 75,
            column: 38
          },
          end: {
            line: 75,
            column: 73
          }
        }, {
          start: {
            line: 76,
            column: 8
          },
          end: {
            line: 76,
            column: 39
          }
        }],
        line: 75
      },
      "4": {
        loc: {
          start: {
            line: 95,
            column: 2
          },
          end: {
            line: 109,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 95,
            column: 2
          },
          end: {
            line: 109,
            column: 3
          }
        }, {
          start: {
            line: 102,
            column: 9
          },
          end: {
            line: 109,
            column: 3
          }
        }],
        line: 95
      },
      "5": {
        loc: {
          start: {
            line: 98,
            column: 9
          },
          end: {
            line: 98,
            column: 52
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 98,
            column: 9
          },
          end: {
            line: 98,
            column: 17
          }
        }, {
          start: {
            line: 98,
            column: 21
          },
          end: {
            line: 98,
            column: 52
          }
        }],
        line: 98
      },
      "6": {
        loc: {
          start: {
            line: 105,
            column: 9
          },
          end: {
            line: 105,
            column: 52
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 105,
            column: 9
          },
          end: {
            line: 105,
            column: 17
          }
        }, {
          start: {
            line: 105,
            column: 21
          },
          end: {
            line: 105,
            column: 52
          }
        }],
        line: 105
      },
      "7": {
        loc: {
          start: {
            line: 112,
            column: 7
          },
          end: {
            line: 121,
            column: 7
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 113,
            column: 8
          },
          end: {
            line: 115,
            column: 18
          }
        }, {
          start: {
            line: 117,
            column: 8
          },
          end: {
            line: 120,
            column: 22
          }
        }],
        line: 112
      },
      "8": {
        loc: {
          start: {
            line: 118,
            column: 11
          },
          end: {
            line: 118,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 118,
            column: 20
          },
          end: {
            line: 118,
            column: 55
          }
        }, {
          start: {
            line: 118,
            column: 58
          },
          end: {
            line: 118,
            column: 61
          }
        }],
        line: 118
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "fbba49264e4c24b7f1245f062d01a0708266f6e0"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1ga3pmbvzg = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1ga3pmbvzg();
var Wrapper = (cov_1ga3pmbvzg().s[0]++, (0, _utils.withThemedStyles)(_styledComponents.default.div.attrs({
  className: "g-DropDown-Option"
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n      display: flex;\n      padding: ", " ", ";\n      padding-left: ", ";\n      background: ", ";\n      &:hover {\n        cursor: pointer;\n        background: ", ";\n      }\n    "])), _stylingConstants.default.spacing.small, _stylingConstants.default.spacing.medium, function (props) {
  cov_1ga3pmbvzg().f[0]++;
  cov_1ga3pmbvzg().s[1]++;
  return props.indentated ? (cov_1ga3pmbvzg().b[0][0]++, _stylingConstants.default.spacing.medium) : (cov_1ga3pmbvzg().b[0][1]++, _stylingConstants.default.spacing.xsmall);
}, function (props) {
  cov_1ga3pmbvzg().f[1]++;
  cov_1ga3pmbvzg().s[2]++;
  return props.isActive ? (cov_1ga3pmbvzg().b[1][0]++, _stylingConstants.default.color.disabledBackground) : (cov_1ga3pmbvzg().b[1][1]++, _stylingConstants.default.color.baseBackground);
}, _stylingConstants.default.color.disabledBackground)), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n      display: flex;\n      color: ", ";\n      background-color: ", ";\n      font-size: ", ";\n      line-height: ", ";\n      font-weight: ", ";\n      padding: ", ";\n\n      :hover {\n        background-color: ", ";\n      }\n    "])), _themeMapper.evolutionTheme.dropdown.option.color, _themeMapper.evolutionTheme.dropdown.option.bgColor, _themeMapper.evolutionTheme.dropdown.option.fontSize, _themeMapper.evolutionTheme.dropdown.option.lineHeight, _themeMapper.evolutionTheme.dropdown.option.fontWeight, _themeMapper.evolutionTheme.dropdown.option.padding, _themeMapper.evolutionTheme.dropdown.option.hover.bgColor))));
var IconWrapper = (cov_1ga3pmbvzg().s[3]++, (0, _styledComponents.default)(Wrapper)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  justify-content: ", ";\n  padding-left: 5px;\n  padding-right: 0.25rem;\n  font-size: 14px;\n  font-weight: 100;\n"])), function (props) {
  cov_1ga3pmbvzg().f[2]++;
  cov_1ga3pmbvzg().s[4]++;
  return props.isActive ? (cov_1ga3pmbvzg().b[2][0]++, 'space-between') : (cov_1ga3pmbvzg().b[2][1]++, 'flex-end');
}));
var Picture = (cov_1ga3pmbvzg().s[5]++, _styledComponents.default.i(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n  position: relative;\n  vertical-align: middle;\n  min-width: 20px;\n  margin-right: ", ";\n  background-image: url(", ");\n  background-repeat: no-repeat;\n  background-size: contain;\n  background-position: center;\n"])), _stylingConstants.default.spacing.xsmall, function (props) {
  cov_1ga3pmbvzg().f[3]++;
  cov_1ga3pmbvzg().s[6]++;
  return props.source;
}));
var Label = (cov_1ga3pmbvzg().s[7]++, (0, _utils.withThemedStyles)(_styledComponents.default.span.attrs({
  className: "g-MultiDropDown-OptionLabel"
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n      position: relative;\n      color: ", ";\n    "])), function (props) {
  cov_1ga3pmbvzg().f[4]++;
  cov_1ga3pmbvzg().s[8]++;
  return (cov_1ga3pmbvzg().b[3][0]++, props.theme.multiDropdown) && (cov_1ga3pmbvzg().b[3][1]++, props.theme.multiDropdown.colorText) || (cov_1ga3pmbvzg().b[3][2]++, _stylingConstants.default.color.baseText);
})), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n      position: relative;\n      color: ", ";\n    "])), _themeMapper.evolutionTheme.multiDropdown.color))));
var ActiveLabel = (cov_1ga3pmbvzg().s[9]++, _styledComponents.default.span(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2.default)(["\n  padding-right: 5px;\n"]))));

/**
 * Container of differents options
 */
cov_1ga3pmbvzg().s[10]++;
var Option = function Option(_ref) {
  var value = _ref.value,
    onSelected = _ref.onSelected,
    indentated = _ref.indentated,
    active = _ref.active,
    single = _ref.single,
    showIcon = _ref.showIcon,
    isIconDropdown = _ref.isIconDropdown;
  cov_1ga3pmbvzg().f[5]++;
  var optionItem = (cov_1ga3pmbvzg().s[11]++, null);
  cov_1ga3pmbvzg().s[12]++;
  if (single) {
    cov_1ga3pmbvzg().b[4][0]++;
    cov_1ga3pmbvzg().s[13]++;
    optionItem = /*#__PURE__*/_react.default.createElement(_react.Fragment, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 97,
        columnNumber: 7
      }
    }, (cov_1ga3pmbvzg().b[5][0]++, showIcon) && (cov_1ga3pmbvzg().b[5][1]++, /*#__PURE__*/_react.default.createElement(Picture, {
      source: value.icon,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 98,
        columnNumber: 22
      }
    })), /*#__PURE__*/_react.default.createElement(Label, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 99,
        columnNumber: 9
      }
    }, value.label));
  } else {
    cov_1ga3pmbvzg().b[4][1]++;
    cov_1ga3pmbvzg().s[14]++;
    optionItem = /*#__PURE__*/_react.default.createElement(_checkbox.default, {
      checked: active,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 104,
        columnNumber: 7
      }
    }, (cov_1ga3pmbvzg().b[6][0]++, showIcon) && (cov_1ga3pmbvzg().b[6][1]++, /*#__PURE__*/_react.default.createElement(Picture, {
      source: value.icon,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 105,
        columnNumber: 22
      }
    })), /*#__PURE__*/_react.default.createElement(Label, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 106,
        columnNumber: 9
      }
    }, value.label));
  }
  cov_1ga3pmbvzg().s[15]++;
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 111,
      columnNumber: 5
    }
  }, !isIconDropdown ? (cov_1ga3pmbvzg().b[7][0]++, /*#__PURE__*/_react.default.createElement(Wrapper, {
    isActive: active,
    indentated: indentated,
    onClick: function onClick() {
      cov_1ga3pmbvzg().f[6]++;
      cov_1ga3pmbvzg().s[16]++;
      return onSelected(value);
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 113,
      columnNumber: 9
    }
  }, optionItem)) : (cov_1ga3pmbvzg().b[7][1]++, /*#__PURE__*/_react.default.createElement(IconWrapper, {
    isActive: active,
    indentated: indentated,
    onClick: function onClick() {
      cov_1ga3pmbvzg().f[7]++;
      cov_1ga3pmbvzg().s[17]++;
      return onSelected(value);
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 117,
      columnNumber: 9
    }
  }, active ? (cov_1ga3pmbvzg().b[8][0]++, /*#__PURE__*/_react.default.createElement(ActiveLabel, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 118,
      columnNumber: 21
    }
  }, "\u2713")) : (cov_1ga3pmbvzg().b[8][1]++, ' '), optionItem)));
};
cov_1ga3pmbvzg().s[18]++;
Option.propTypes = {
  /**
   * Object that contains the value of input and the icon source
   */
  value: _type.SingleOptionType,
  /**
   * Method to be called when select an option
   */
  onSelected: _propTypes.default.func.isRequired,
  /**
   * Bool to add an indentation to the option (for group options)
   */
  indentated: _propTypes.default.bool,
  /**
   * Indicates if the option is selected
   */
  active: _propTypes.default.bool,
  /**
   * Indicate if accept single selection
   */
  single: _propTypes.default.bool,
  /**
   * Indicate if show the icon
   */
  showIcon: _propTypes.default.bool,
  isIconDropdown: _propTypes.default.bool
};
cov_1ga3pmbvzg().s[19]++;
Option.defaultProps = {
  value: {},
  indentated: false,
  active: false,
  single: false,
  showIcon: true,
  isIconDropdown: false
};
var _default = exports.default = Option;